
import React from 'react';

import { Dialog } from '../../../../base/dialog';
import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import AbstractStopLocalRecordingDialog, {
    mapStateToProps
} from '../AbstractStopLocalRecordingDialog';

/**
 * React Component for getting confirmation to stop a local recording session in progress.
 *
 * @augments Component
 */
class StopLocalRecordingDialog extends AbstractStopLocalRecordingDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        return (
            <Dialog
                okKey = 'dialog.stopRecording'
                onSubmit = { this._onSubmit }
                titleKey = 'dialog.stopRecording'
                width = 'small'>
                <div className = 'stop-local-recording-dialog'>
                    {this.props.t('dialog.stopRecordingWarning')}
                </div>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
}

export default translate(connect(mapStateToProps)(StopLocalRecordingDialog));
